import gtm from '@/utils/gtm';
import classNames from 'classnames';
import React from 'react';
import EfImgVideo from '../ef-img-video';
import './index.scss';

export interface EfCardHoverAProps {
    /**
     * 主题色
     */
    theme?: 'default' | 'white' | 'black';
    /**
     * 资源链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;
    /**
     * 标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 标题上的标签
     */
    label?: string;
    /**
     * 更多详情-链接
     */
    href?: string;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 埋点数据-position 填了才会触发埋点,锚点要到达的位置的标题
     */
    gtm_position?: string;
    /**
     * 埋点数据
     */
    dataLayer?: any[];
}

/**
 * 维护:谢保林
 *
 * 通用卡片
 */
const EfCardHoverA: React.FC<EfCardHoverAProps> = ({
    theme = 'default',
    isVideo = false,
    pc,
    h5,
    poster,
    posterH5,
    title,
    desc,
    label,
    href,
    className,
    gtm_position,
    dataLayer,
    ...reset
}) => {
    const prefixCls = `ef-card-hover-a`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
    });
    // 点击锚点
    const hrefHandle = () => {
        if (dataLayer && dataLayer.length) {
            // [不使用]自定义埋点
            gtm.push(dataLayer[0]);
        } else if (gtm_position) {
            // [使用]自定义埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: gtm_position,
                button_name: title,
            });
        }
    };

    return (
        <div className={classes} {...reset} onClick={hrefHandle}>
            <a href={href} className={`${prefixCls}-img`}>
                <EfImgVideo isVideo={isVideo} pc={pc} h5={h5} poster={poster} posterH5={posterH5} />
            </a>
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-msg-in`}>
                    {label && <div className={`${prefixCls}-label`}>{label}</div>}
                    {title && <div className={`${prefixCls}-title`}>{title}</div>}
                    {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                    <span className={`${prefixCls}-icon`}>
                        <span className={`${prefixCls}-icon-in`}></span>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default EfCardHoverA;
